exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper--3Un9f {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 16px;\n  font-weight: 400;\n}\n\n.wrapper--3Un9f .icon-wrapper--3Gfdp {\n  stroke: #878787;\n  padding: 5px;\n  -webkit-transform: scale3d(0.9, 0.9, 0.9);\n          transform: scale3d(0.9, 0.9, 0.9);\n  margin-bottom: -2px;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "wrapper--3Un9f",
	"icon-wrapper": "icon-wrapper--3Gfdp"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/components/utils/HintedCurrencyCode/HintedCurrencyCode.m.scss
// module id = 1535
// module chunks = 0